module.exports = __webpack_public_path__ + "static/media/menuScale.d804aa4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuScale.svg
// module id = 482
// module chunks = 0